<template>
  <div class="membership_benefit_width">
    <v-dialog v-model="membershipTermSettingModal" max-width="790">
      <v-card class="membership_benefit_width overflow-y-auto overflow-x-auto">
        <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-2">멤버십 혜택 내역 등록</v-card-title>

        <v-card-text class="pl-5 pb-0">
          <p class="mb-0">
            쇼핑몰에 노출하려는 멤버십 혜택 정보를 입력해주세요.
          </p>
        </v-card-text>

        <v-row class="pt-0 pb-0 mt-2 ml-5 mr-0 mb-0 " width="750">
          <div style="background-color: rgb(248, 248, 248); width:750px;" class="pa-7">
            <p class="font-weight-bold body-1 black--text mb-2">
              설정하신 멤버십 혜택 내역을 참고하세요.
            </p>
            <p v-if="membership_info.ship_benefits == 'T'" class="membershipSettingTextInfo mb-0 float-left" style="width:347px;">
              ㆍ 무료 배송 제공
            </p>
            <p
              v-if="membership_info.discount_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:347px;"
            >
              ㆍ 구매시
              {{ membership_info.discount_information.amount_discount | comma
              }}<!-- 공백 제거용 주석
                    -->
              <font v-if="membership_info.discount_information.discount_unit == 'W'">
                {{ currency_code === "KRW" ? "원" : currency_code }}</font
              >
              <font v-else>%</font>
              할인
            </p>
            <p
              v-if="membership_info.points_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0  float-left"
              style="width:347px;"
            >
              ㆍ 구매시 적립금
              {{ membership_info.points_information.amount_discount | comma
              }}<!-- 공백 제거용 주석
                    -->
              <font v-if="membership_info.points_information.discount_unit == 'W'">
                {{ currency_code === "KRW" ? "원" : currency_code }}</font
              >
              <font v-else>%</font>
              지급
            </p>
            <p
              v-if="membership_info.mobile_discount_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0  float-left"
              style="width:347px;"
            >
              ㆍ 모바일 구매시 추가
              <font>
                {{ membership_info.mobile_discount_information.amount_discount | comma
                }}<!-- 공백 제거용 주석
                    --></font
              >
              <font v-if="membership_info.mobile_discount_information.discount_unit == 'W'">
                {{ currency_code === "KRW" ? "원" : currency_code }}</font
              >
              <font v-else>%</font>
              할인
            </p>

            <p
              v-if="membership_info.mobile_points_information.amount_discount > 0"
              class="membershipSettingTextInfo mb-0 float-left"
              style="width:347px;"
            >
              ㆍ 모바일 구매시 추가 적립금
              {{ membership_info.mobile_points_information.amount_discount | comma
              }}<!-- 공백 제거용 주석
                    --><font v-if="membership_info.mobile_points_information.discount_unit == 'W'">
                {{ currency_code === "KRW" ? "원" : currency_code }}</font
              >
              <font v-else>%</font>

              지급
            </p>
            <p v-if="membership_info.coupon_info.length > 0" class="membershipSettingTextInfo mb-0 float-left" style="width:347px;">
              ㆍ 멤버십 회원 전용 쿠폰
              {{ membership_info.coupon_info.length }}개 지급
            </p>
            <p v-if="membership_info.total_point > 0" class="membershipSettingTextInfo mb-0 float-left" style="width:347px;">
              ㆍ 멤버십 회원 전용 적립금
              {{ membership_info.total_point | comma }} {{ currency_code === "KRW" ? "원" : currency_code }} 지급
            </p>
            <p v-if="membership_info.category_info.length > 0" class="membershipSettingTextInfo mb-0 float-left" style="width:347px;">
              ㆍ 멤버십 회원 전용 상품 제공
            </p>
          </div>
        </v-row>

        <div class="d-inline-block mt-3 ml-5">
          <div class="mt-0">
            <v-card width="750" outlined class="pt-0">
              <div class="d-flex">
                <v-card-text class="pa-0 d-flex align-center" style="max-width:200px; background-color:#f0f7ff; height:50px;">
                  <div class="float-left">
                    <p style="font-size: 1rem;" class="mb-0 mt-0 ml-5 font-weight-medium black--text">
                      아이콘 이미지
                    </p>
                  </div>
                </v-card-text>
                <v-card-text class="pa-0 d-flex ml-5" style="align-items: center;">
                  <div class="float-left">
                    <div style="align-items: center;display: flex;">
                      <v-avatar class="float-left mt-0 mb-0" size="40">
                        <img :src="benefits.image" @error="getDefaultImage" />
                      </v-avatar>
                      <v-btn
                        depressed
                        small
                        color="#2196f3"
                        class="font-weight-black mr-0 white--text ml-5 mb-0 mt-0  float-left"
                        aling="left"
                        @click="showImageUploadBenefitd()"
                        >+ 등록</v-btn
                      >
                      <p class="mb-0 ml-3" style="font-size:15px ; color:rgba(0, 0, 0, 0.6) !important;">
                        권장이미지 : 125px * 125px / 5M 이하 / gif, png, jpg(jpeg)
                      </p>
                    </div>
                  </div>
                </v-card-text>
              </div>

              <v-divider></v-divider>

              <div class="d-flex">
                <v-card-text class="pa-0 d-flex align-center" style="max-width:200px; background-color:#f0f7ff; height:50px;">
                  <div class="float-left">
                    <p style="font-size: 1rem;" class="mb-0 mt-0 ml-5 font-weight-medium black--text">
                      혜택 타이틀
                    </p>
                  </div>
                </v-card-text>
                <v-card-text class="pa-0  d-inline-flex align-center ml-5">
                  <div class="float-left d-inline-flex align-center">
                    <v-text-field
                      v-model="benefits.title"
                      outlined
                      class="mt-0 mb-0"
                      hide-details
                      dense
                      style="width:510px;"
                    ></v-text-field>
                  </div>
                </v-card-text>
              </div>

              <v-divider></v-divider>

              <div class="d-flex">
                <v-card-text class="pa-0 d-flex align-center" style="max-width:200px; background-color:#f0f7ff; min-height:50px;">
                  <div class="float-left">
                    <p style="font-size: 1rem;" class="mb-0 mt-0 ml-5 font-weight-medium black--text">
                      상세 내역
                    </p>
                  </div>
                </v-card-text>
                <v-card-text class="pa-0  d-inline-flex align-center ml-5 mt-3 mb-3" v-if="benefits.use_detail == 'enabled'">
                  <div>
                    <div class="float-left d-inline-flex align-center mb-3">
                      <div>
                        <v-container fluid class="pa-0 float-left" style="max-width:240px;">
                          <v-radio-group row class="mt-0" hide-details v-model="benefits.use_detail">
                            <v-radio value="disabled" class="mb-0">
                              <template v-slot:label>
                                <p class="mb-0 black--text">사용안함</p>
                              </template>
                            </v-radio>
                            <v-radio value="enabled" class="mb-0">
                              <template v-slot:label>
                                <p class="mb-0 black--text">사용함</p>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-container>
                      </div>
                    </div>
                    <div v-if="benefits.use_detail == 'enabled'" class="d-inline-flex">
                      <v-textarea
                        v-model="benefits.detail"
                        outlined
                        no-resize
                        style="font-size:15px; width:510px;"
                        height="480"
                        hide-details
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
                <v-card-text class="pa-0  d-inline-flex align-center ml-5" v-else>
                  <div>
                    <div class="float-left d-inline-flex align-center">
                      <div>
                        <v-container fluid class="pa-0 float-left" style="max-width:240px;">
                          <v-radio-group row class="mt-0" hide-details v-model="benefits.use_detail">
                            <v-radio value="disabled" class="mb-0">
                              <template v-slot:label>
                                <p class="mb-0 black--text">사용안함</p>
                              </template>
                            </v-radio>
                            <v-radio value="enabled" class="mb-0">
                              <template v-slot:label>
                                <p class="mb-0 black--text">사용함</p>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-container>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </div>
            </v-card>
          </div>
        </div>

        <v-btn
          color="black"
          hide-details
          depressed
          class="ml-5 mt-5 mb-5 white--text"
          @click="membershipTermSettingModal = false"
          width="371"
          >닫기</v-btn
        >
        <v-btn color="primary" hide-details class="white--text ml-2 mt-5 mb-5 pl-4 pr-4" depressed width="371" @click="save()">매칭</v-btn>
      </v-card>
    </v-dialog>
    <ImageUploadBenefit ref="ImageUploadBenefit"></ImageUploadBenefit>
  </div>
</template>

<script>
import ImageUploadBenefit from "@/components/membership/membership_manage/modal/ImageUploadBenefit.vue";
import Filters from "@/libs/membership/filters.js";

export default {
  data: () => {
    return {
      membershipTermSettingModal: false,
      benefits: {
        title: "",
        image: "",
        detail: "",
        use_detail: "disabled",
      },
      membership_info: {
        membership_id: "",
        membership_name: "",
        membership_price: 0,
        use_discount: "",
        subscription_shipments_cycle: "",
        group_no: "",
        group_name: "",
        // 무료배송
        ship_benefits: "",
        //구매할인
        discount_information: {
          amount_product: 0,
          amount_discount: 0,
          discount_unit: "",
        },
        //모바일 추가 할인
        mobile_discount_information: {
          amount_product: 0,
          amount_discount: 0,
          discount_unit: "",
        },
        //구매 적립금 지급
        points_information: {
          amount_product: 0,
          amount_discount: 0,
          discount_unit: "",
        },
        //모바일 추가 적립
        mobile_points_information: {
          amount_product: 0,
          amount_discount: 0,
          discount_unit: "",
        },
        coupon_info: [
          {
            coupon_no: "",
            coupon_issued_type: "",
            coupon_subscription: "",
          },
        ],
        revert_coupon: "",
        point_info: [
          {
            point: 0,
            point_issued_type: "",
            point_subscription: "",
          },
        ],
        revert_point: "",
        category_info: [
          {
            category_no: "",
            category_product_count: "",
          },
        ],
        membership_status: "",
      },
    };
  },
  computed: {
    currency_code: function() {
      return this.$store.state.currency_code;
    },
  },
  methods: {
    show: function(membership_info) {
      this.membershipTermSettingModal = true;
      this.benefits = {
        title: "",
        image: "",
        detail: "",
        use_detail: "disabled",
      };
      this.membership_info = membership_info;
    },
    save: async function() {
      if (!this.benefits.title) {
        alert("혜택 타이틀을 입력해주세요.");
        return false;
      }
      if (!this.benefits.image) {
        alert("아이콘 이미지를 등록해주세요.");
        return false;
      }
      if (this.benefits.use_detail == "enabled" && !this.benefits.detail) {
        alert("상세 내역을 입력해주세요.");
        return false;
      }
      this.$parent.mall_benefit_part.benefits.push(this.benefits);
      this.reset();
      this.membershipTermSettingModal = false;
    },
    showImageUploadBenefitd: function() {
      this.$refs.ImageUploadBenefit.show();
    },
    reset: function() {
      this.benefits = {
        title: "",
        image: "",
        detail: "",
        use_detail: "disabled",
      };
    },
    getDefaultImage: function(event) {
      event.target.src = "/membership/image/default_image.png";
    },
  },
  components: {
    ImageUploadBenefit,
  },
  filters: Filters,
};
</script>
